module.exports = __webpack_public_path__ + "img/q3.9d2eaef6.jpg";